module.exports = __webpack_public_path__ + "static/media/herobanner_illustration.f5a04230.svg";